import { FC } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "@hr/common/Button.tsx";
import { Blocker } from "react-router";

export interface UnsavedChangesWarningProps {
  isShow: boolean;
  closeAction: () => void;
  discardAction: () => void;
  saveAction: () => void;
  blocker: Blocker;
}

export const UnsavedChangesWarning: FC<UnsavedChangesWarningProps> = ({
  isShow,
  closeAction,
  discardAction,
  saveAction,
  blocker,
}) => {
  const { t } = useTranslation();

  const handleDiscard = () => {
    discardAction();

    if (blocker) {
      blocker.proceed();
      blocker.reset();
    }
  };

  const handleSave = () => {
    saveAction();

    if (blocker) {
      blocker.proceed();
      blocker.reset();
    }
  };

  return (
    <Modal show={isShow} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("DiscardUnsavedChanges","Hylkää tallentamattomat muutokset")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex justify-content-center align-items-center">
        {t("DiscardUnsavedInfo","Sinulla on tallentamattomia muutoksia, haluatko hylätä ne?")}
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-st">
        <Button variant="outline-secondary" onClick={closeAction}>
          {t("Close","Sulje")}
        </Button>
        <Button variant="primary" onClick={handleDiscard}>
          {t("DiscardChanges","Hylkää muutokset")}
        </Button>
        <Button variant="primary" onClick={handleSave}>
          {t("SaveChanges","Tallenna muutokset")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
